module.exports = {
      id: "share-pintrest-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#share-pintrest",
      toString: function () {
        return this.url;
      }
    }